<template>
  <div>
    <base-dialog :show="!!error" title="An error occurred" @close="handleError">
      <p>{{ error }}</p>
    </base-dialog>
    <base-dialog :show="isLoading" :title="submitButtonCaption" fixed>
      <base-spinner></base-spinner>
    </base-dialog>
    <base-card>

      <div class="logo-field">
        <router-link to="/"><main-logo /></router-link>
      </div>

      <template v-if="mode==='email'">
        <div class="login-title">암호를 잊어 버리셨나요?</div>  
        <div class="sub_description"> 지정하신 e-mail로 인증 번호를 보내드립니다.</div>      
      </template>
      <template v-else>
        <div class="login-title">비밀번호 변경</div>  
        <div class="sub_description"> 이메일로 받은 이메일을 입력하시고 비밀번호를 변경하세요</div>      
      </template>

      <fieldset>
        <legend>비밀번호 재설정</legend>
        <div class="login_set">

          <dl id="login-field" class="input_list">
            <template  v-if="mode==='email'">
              <dt class="display_none" >
                <label for="mb_id">이메일 입력</label>
              </dt>
              <dd class="dd_mb_id" >
                <input type="email" name="email" v-model.trim="email.val"  placeholder="이메일 입력" autocomplete="off" 
                @blur="clearValidity('email')"
                @keyup.enter="submitForm2"
                >
              </dd>
            </template> 

            <template v-else>
              <dt class="display_none" >
                <label for="email_token">인증번호 입력</label>
              </dt>
              <dd class="email_token" >
                <input type="text"  name="email_token"  v-model.trim="emailToken.val" placeholder="인증번호 입력" autocomplete="off" 
                @blur="clearValidity('emailToken')">
              </dd>

              <dt class="display_none" >
                <label for="mb_password">비밀번호 입력</label>
              </dt>
              <dd class="bt_none" >
                <input type="password"  name="password"  v-model.trim="password.val" placeholder="비밀번호 입력" autocomplete="off"
                 @blur="clearValidity('password')">
              </dd>

              <dt class="display_none" >
                <label for="mb_password">비밀번호 확인</label>
              </dt>
              <dd class="bt_none" >
                <input type="password"  name="password"  v-model.trim="passwordConfirm.val" placeholder="비밀번호 확인" autocomplete="off" 
                @blur="clearValidity('passwordConfirm')">
              </dd>
            </template> 
          </dl>

          <div class="acc">
            <ul>
              <li>
                <a href="/auth/findid" onclick="javascript:window.resizeTo(700,600);">아이디찾기</a>
                <span class="bar"></span>
              </li>
              <li>
                <router-link to="/auth/login">로그인</router-link>
                <span class="bar"></span>
              </li>
              <li>
                <router-link to="/auth/register">
                  <strong>간편회원가입</strong>
                </router-link>
              </li>
            </ul>
          </div>
          <p v-if="!email.isValid" class="alert-valid">
            이메일을 형식에 맞게 입력해 주세요.
          </p>
          <p v-if="!emailToken.isValid" class="alert-valid">
            인증번호를 입력해 주세요.
          </p>
          <p v-if="!password.isValid" class="alert-valid">
            비밀번호를 확인해 주세요. 최소 6글자 이상입니다.
          </p>
            <p v-if="!passwordConfirm.isValid" class="alert-valid">
            비밀번호가 일치 하지 않습니다. 
          </p>
          
          <base-button :mode="switchModeButtonCaption" @click="submitForm2"
          ref="test">{{submitButtonCaption}}</base-button>
         
        </div>
      </fieldset>
      
      <div class="footer">Copyright (c){{ siteName }}. All Rights Reserved.</div>

    </base-card>
  </div>
</template>

<script>
//import * as auth from '@/services/auth_service';

export default {
  props:[
    'prevroute','path'
  ],
  data() {
    return {
      email: {val:"",isValid:true},
      password: {val:"", isValid:true},
      passwordConfirm: {val:"", isValid:true},
      emailToken:{val:"",isValid:true},      
      mode: "email",
      isLoading: false,
      error: null,
    };
  },
  computed: {
    siteName(){
      return this.$store.state.siteName;
    },  
    submitButtonCaption() {
      if (this.mode === "email") {
        return "인증번호 발송";
      } else {
        return "비밀번호 변경";
      }
    },
    switchModeButtonCaption() {
      if (this.mode === "email") {
        return "skyblue";
      } else {
        return "red";
      }
    },
  },
  methods: {
    validateForm() {
      this.formIsValid = true;
      if(this.mode==='email'){
        //이메일로 인증번호 발송할때 체크
        if(this.email.val === "" || !this.email.val.includes("@") ) 
        {
          this.email.isValid = false;
          this.formIsValid = false;        
        }
      }else{
        //비밀번호 변경할때 체크
        if(this.emailToken.val === "") 
        {
          this.emailToken.isValid = false;
          this.formIsValid = false;  
          return;      
        }  
        if(this.password.val === "" || this.passwordConfirm.val === "" || this.password.val.length < 6 ) 
        {
          this.password.isValid = false;
          this.formIsValid = false;   
           return;         
        }  
        if( this.password.val  !== this.passwordConfirm.val) 
        {
          this.passwordConfirm.isValid = false;
          this.formIsValid = false;
          return;            
        } 
      }     
    },
    async submitForm2() {      
     
      this.validateForm();
      if (!this.formIsValid) {
        return;
      }
      this.isLoading = true;
      const actionPayload = {
        email: this.email.val,
        emailtoken:this.emailToken.val,
        password:this.password.val,
        password_confirmation: this.passwordConfirm.val,       
      };

      try {
        //const response = await auth.login(actionPayload);
        let dispatchmethod ="sendEmailToken";
        if(this.mode !=="email")
        {
          dispatchmethod ="resetPassword";
        }        
       
        const response = await this.$store.dispatch("users/"+ dispatchmethod , actionPayload);
        console.log(response);
        // if(this.$route.params.prevroute)
        // {
        //   this.$router.push({ name: this.$route.params.prevroute});
        //  if(this.prevroute)
        // {
        //   // this.$router.push({ name: this.prevroute});
        //   this.$router.push({ path: this.path});          
        //   //만약 팝업으로 로그인처리 할경우는 팝업은 닫고 부모경로에 주소를 바꿔줘야하는데 아래 코드 참고
        //   //<a href="" target="_self" onclick="window.opener.parent.location.href = '주소';window.close();">
        // }else{
        //   this.$router.go(-1);
        //   //this.$router.replace("/");
        // }     
        if(response.status_code===200)
        {
          if( this.mode==="resetpw")
          {
            //로그인 페이지로 이동
            this.$router.push({ name: 'auth_login'});
          }
          this.mode="resetpw";
        }

        this.$flashMessage.show({
          type: response.status_code===200? "info":"error",
          title: response.message,
          message: response.message,
        });
      } catch (error) {
        console.log(error.response);
        switch (error.response.status) {
          case 422:
            this.$flashMessage.show({
              type: "error",
              title: "유효하지 않은 데이터 입력입니다.",
              message: "유효하지 않은 데이터 입력입니다.",
            });
            break;
          case 401:
            this.$flashMessage.show({
              type: "error",
              title: error.response.data.message,
              message: error.response.data.message,
            });
            break;
          case 500:
            this.$flashMessage.show({
              type: "error",
              title: error.response.data.message,
              message: error.response.data.message,
            });
            break;
          default:
            this.$flashMessage.show({
              type: "error",
              title: "특정 문제가 생겨 정상 등록이 되지 않았습니다!",
              message: "특정 문제가 생겨 정상 등록이 되지 않았습니다!",
            });
            break;
        }
      }
      this.isLoading = false;
    },
    switchAuthMode() {
      if (this.mode === "login") {
        this.mode = "signup";
      } else {
        this.mode = "login";
      }
    },
    handleError() {
      this.error = null;
    },
    clearValidity(input) {
      this[input].isValid = true;
    },
  },
};
</script>

<style lang="scss" scoped>
form {
  margin: 1rem;
  padding: 1rem;
  padding-top:0;
}
.logo-field{
  text-align:center;
  padding:20px 0;
}
.login-title{
  font-weight:bold;
  padding-left:2rem;
  font-size:20px;
  font-family:malgungothic;
}
.sub_description{
  margin-top:10px;
  padding-left:2rem;
  color:#999;
}
fieldset{
  border: 0;
  legend{display:none;}
  font-family:굴림,gulim;
  .login_set{
    .input_list{

        input{
            padding:0 20px;
            height:49px;
            border: 1px solid #dadada;
            font-size: 12px;
            width:100%;
        }
        .email_token input{
          border: 1px solid #b72e00;
        }
        .bt_none input{
            border-top:1px solid #fff !important;
        }

    }
  }

  .acc{
      margin:20px 0;
      display:flex;
      justify-content: flex-end;
      font-size:12px;
      color: #999;
      ul{
          display:flex;

          li{
              a{
                  line-height: 19px;
                  color: #999;
              }
              .bar{
                margin: 4px 10px 0;
                width: 1px;
                height: 11px;
                background-color: #e5e5e5;
                display: inline-block;
              }
          }
      }
  }
  .alert-valid{
      font-size:12px;
      color:#b72e00;
  }
}
.footer{
    font-size: 10px;
    font-family: Arial,Helvetica,sans-serif;
    text-align: center;
    color: #999;
}


</style>
